import Loading from './LoadingScreen'

export default Loading
export { Loading }
